"use strict";

var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(object, property, receiver) { var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc && desc.writable) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _inherits = function (subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };

var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CallBuilder = require("./call_builder").CallBuilder;

var AssetPairShortCallBuilder = exports.AssetPairShortCallBuilder = (function (_CallBuilder) {
  function AssetPairShortCallBuilder(serverUrl) {
    _classCallCheck(this, AssetPairShortCallBuilder);

    _get(Object.getPrototypeOf(AssetPairShortCallBuilder.prototype), "constructor", this).call(this, serverUrl);
    this.defaultUrl = "exchange";
    this.url.segment(this.defaultUrl);
  }

  _inherits(AssetPairShortCallBuilder, _CallBuilder);

  _createClass(AssetPairShortCallBuilder, {
    assetToken: {
      value: (function (_assetToken) {
        var _assetTokenWrapper = function assetToken(_x) {
          return _assetToken.apply(this, arguments);
        };

        _assetTokenWrapper.toString = function () {
          return _assetToken.toString();
        };

        return _assetTokenWrapper;
      })(function (assetToken) {
        this.url.segment(assetToken);
        return this;
      })
    },
    convert: {
      value: (function (_convert) {
        var _convertWrapper = function convert(_x2, _x3, _x4) {
          return _convert.apply(this, arguments);
        };

        _convertWrapper.toString = function () {
          return _convert.toString();
        };

        return _convertWrapper;
      })(function (amount, sourceAsset, destAsset) {
        this.url.segment(convert);
        this.filter.push(["exchange", "convert"]);
        this.url.addQuery("amount", amount);
        this.url.addQuery("source_asset", sourceAsset);
        this.url.addQuery("dest_asset", destAsset);
        return this;
      })
    }
  });

  return AssetPairShortCallBuilder;
})(CallBuilder);


//////////////////
// WEBPACK FOOTER
// ./node_modules/tokend-js-sdk/lib/asset_pair_short_call_builder.js
// module id = Q12R
// module chunks = 0